import { Grid, Icon, Paper, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import { useNavigate, useParams } from "react-router-dom";
import { PrimaryButton } from "../../_components/button/primary.button";
import { toastr } from "../../_components/toastr/toastr";
import { stringToDateFormat } from "../../_helpers/format.helper";
import { handleErrorResponseAxios } from "../../_helpers/handleResponse.helper";
import { accountService } from "../../_services/accounts.service";
import { officialTrainingInformationService } from "../../_services/officialTrainingInformation.service";

export function UserTrainingManage() {

    const { userId } = useParams<{ userId: string }>();

    let navigate = useNavigate();

    const [isLoading, setIsLoading] = useState(false);
    const [initQuantity, setInitQuantity] = useState(0);
    const [isSaving, setIsSaving] = useState(false);
    const [data, setData] = useState<Array<any>>([]);

    useEffect(() => {
        fetchData(userId || accountService.currentUserValue.id);
    }, []);

    function fetchData(id: string) {

        setIsLoading(true)
        return officialTrainingInformationService
            .get(userId || "")
            .then(
                (json: any) => {
                    if (json && json.length) {
                        setInitQuantity(json.length)
                        json.forEach((j: any) => {
                            j.trainingDate = stringToDateFormat(j.trainingDate)
                        })
                    }
                    setData(json);
                }, () => {

                }
            )
            .finally(() => {
                setIsLoading(false);
            });
    }

    function submit() {
        setIsLoading(true);
        setIsSaving(true);

        const formData = new FormData();
        if (data && data.length) {
            data.forEach((f: any, index: number) => {
                formData.append(`officialTrainingInformation[${index}].Id`, f.id || 0);
                formData.append(`officialTrainingInformation[${index}].TrainingDate`, f.trainingDate || "");
                formData.append(`officialTrainingInformation[${index}].TrainingInfo`, f.trainingInfo || "");
                formData.append(`officialTrainingInformation[${index}].UserId`, userId || "");
            })
        }

        formData.append(`UserId`, userId || "");

        return officialTrainingInformationService
            .post(formData)
            .then(
                (json) => {
                    toastr.success("Training Information saved successfully");
                }, handleErrorResponseAxios
            )
            .finally(() => {
                setIsLoading(false);
                setIsSaving(false)
            });
    }

    return (
        <>
            {!isLoading && data &&
                <Paper>


                    <ValidatorForm
                        onSubmit={submit}
                        noValidate>

                        <Grid container spacing={2} sx={{ mt: 0 }}>

                            <Grid item xs={12}>
                                <Typography variant="h6" textAlign="center">Training Information</Typography>
                            </Grid>

                            {(accountService.isAdmin) &&
                                <Grid item xs={12}>
                                    <PrimaryButton
                                        type="button"
                                        variant="primary"
                                        onClick={() => { setData((_data) => ([..._data, {}])) }} >
                                        <Icon>add</Icon> Add Another Training Information
                                    </PrimaryButton>
                                </Grid>
                            }

                            {(!data || !(data.length > 0 || initQuantity > 0)) &&
                                <Grid item xs={12}>
                                    <p>No Official Training Information</p>
                                </Grid>
                            }

                            {(data && data.length > 0) && data.map((d: any, index: number) =>
                                <>
                                    <Grid item xs={accountService.isAdmin ? 6 : 7}>
                                        <TextValidator
                                            key={index + "trainingInfo"}
                                            label="Training Info"
                                            value={data[index].trainingInfo}
                                            name="trainingInfo"
                                            required
                                            disabled={!accountService.isAdmin}
                                            fullWidth
                                            validators={['required']}
                                            errorMessages={['This field is required']}
                                            onChange={(event) => {
                                                setData((_data: any) => {
                                                    {
                                                        var __data = [..._data];
                                                        __data[index].trainingInfo = (event.target as any).value;
                                                        return __data;
                                                    }
                                                })
                                            }}
                                            InputLabelProps={{
                                                shrink: d[index]?.trainingInfo,
                                            }}
                                            variant="filled"
                                        />
                                    </Grid>
                                    <Grid item xs={accountService.isAdmin ? 4 : 5}>
                                        <TextValidator
                                            key={index + "trainingDate"}
                                            label="Training Date"
                                            value={data[index].trainingDate}
                                            name="trainingDate"
                                            required
                                            fullWidth
                                            type="date"
                                            disabled={!accountService.isAdmin}
                                            validators={['required']}
                                            errorMessages={['This field is required']}
                                            onChange={(event) => {
                                                setData((_data: any) => {
                                                    {
                                                        var __data = [..._data];
                                                        __data[index].trainingDate = stringToDateFormat((event.target as any).value);
                                                        return __data;
                                                    }
                                                })
                                            }}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            variant="filled"
                                        />
                                    </Grid>
                                    {accountService.isAdmin &&
                                        <Grid item xs={2}>
                                            <PrimaryButton
                                                type="button"
                                                variant="remove"
                                                onClick={() => { setData((_data: any) => { _data.splice(index, 1); return [..._data] }) }} />
                                        </Grid>
                                    }
                                </>
                            )}

                            {(accountService.isAdmin && data && (data.length > 0 || initQuantity > 0)) &&
                                <Grid item xs={12}>

                                    <PrimaryButton
                                        type="submit"
                                        variant="success"
                                        disabled={isLoading || isSaving || !accountService.isAdmin}>

                                        Save Training Information
                                    </PrimaryButton>
                                </Grid>
                            }



                        </Grid>

                    </ValidatorForm >
                </Paper>
            }
        </>
    );

}
